import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/button/Button';
import { IButtonProps } from 'components/button/ButtonProps';
import { forwardRef, Ref } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
    padding: unset;
    width: 2.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;

    & .default_icon {
        display: initial;
    }
    & .hover_icon {
        display: none;
    }
    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
        & .default_icon {
            display: none;
        }
        & .hover_icon {
            display: initial;
        }
    }
`;

export type HoverIconButtonProps = IButtonProps & {
    /**
     * The icon to display when not hovering.
     */
    icon: IconDefinition;
    /**
     * The icon to display when hovering.
     */
    hoverIcon: IconDefinition;
    /**
     * The color of the icon.
     */
    color: string;
    /**
     * The color of the icon when hovering. Defaults to the same value as color.
     */
    hoverColor?: string;
    /**
     * The size of the icon, in css units.
     */
    size?: string;
    /**
     * aria label to apply to the button
     */
    ariaLabel?: string;
};

export const HoverIconButton = forwardRef(
    (
        {
            icon,
            hoverIcon,
            color,
            hoverColor = color,
            size,
            ariaLabel,
            disabled,
            ...rest
        }: HoverIconButtonProps,
        ref: Ref<HTMLButtonElement>,
    ) => {
        const style: React.CSSProperties = { fontSize: size };
        return (
            <StyledButton
                aria-label={ariaLabel}
                ref={ref}
                disabled={disabled}
                {...rest}
                tabIndex={0}
                type="button"
            >
                <FontAwesomeIcon
                    className="default_icon"
                    style={style}
                    icon={icon}
                    color={color}
                />
                <FontAwesomeIcon
                    className="hover_icon"
                    style={style}
                    icon={hoverIcon}
                    color={hoverColor}
                />
            </StyledButton>
        );
    },
);
